export default {
  setSkuPerformanceFilter({ commit }, { filterValue, selectedOption, type }) {
    commit('SET_SKU_PERFORMANCE_FILTER', { filterValue, selectedOption, type });
  },
  setSkuPerformanceMultipleFilter({ commit }, { filterValue, selectedOption }) {
    commit('SET_SKU_PERFORMANCE_MULTIPLE_FILTER', {
      filterValue,
      selectedOption,
    });
  },
  setSkuPerformanceFilterChildrenActive({ commit }, { filterValue }) {
    commit('SET_SKU_PERFORMANCE_FILTER_CHILDREN_ACTIVE', { filterValue });
  },
  resetSkuPerformanceFilterChildrenActive({ commit }) {
    commit('RESET_SKU_PERFORMANCE_FILTER_CHILDREN_ACTIVE');
  },
  clearSkuPerformanceActiveFilters({ commit }, { filterValue }) {
    commit('CLEAR_SKU_PERFORMANCE_ACTIVE_FILTERS', { filterValue });
  },
  setSkuPerformanceFilterAddChildren({ commit }, { filterValue, children }) {
    commit('SET_SKU_PERFORMANCE_FILTER_ADD_CHILDREN', {
      filterValue,
      children,
    });
  },
  setSkuPerformanceFilterSearchValue(
    { commit },
    { filterValue, filterSearch }
  ) {
    commit('SET_SKU_PERFORMANCE_FILTER_SEARCH_VALUE', {
      filterValue,
      filterSearch,
    });
  },
  setOpportunityFilter({ commit }, { filterValue, selectedOption, type }) {
    commit('SET_OPPORTUNITY_FILTER', { filterValue, selectedOption, type });
  },
  setOpportunityMultipleFilter({ commit }, { filterValue, selectedOption }) {
    commit('SET_OPPORTUNITY_MULTIPLE_FILTER', {
      filterValue,
      selectedOption,
    });
  },
  setOpportunityFilterChildrenActive({ commit }, { filterValue }) {
    commit('SET_OPPORTUNITY_FILTER_CHILDREN_ACTIVE', { filterValue });
  },
  resetOpportunityFilterChildrenActive({ commit }) {
    commit('RESET_OPPORTUNITY_FILTER_CHILDREN_ACTIVE');
  },
  clearOpportunityActiveFilters({ commit }, { filterValue }) {
    commit('CLEAR_OPPORTUNITY_ACTIVE_FILTERS', { filterValue });
  },
  setOpportunityFilterAddChildren({ commit }, { filterValue, children }) {
    commit('SET_OPPORTUNITY_FILTER_ADD_CHILDREN', {
      filterValue,
      children,
    });
  },
  setOpportunityFilterSearchValue({ commit }, { filterValue, filterSearch }) {
    commit('SET_OPPORTUNITY_FILTER_SEARCH_VALUE', {
      filterValue,
      filterSearch,
    });
  },

  setTempFiltersToFilters({ commit }, payload) {
    commit('SET_TEMP_FILTERS_TO_FILTERS', payload);
  },
  setSearchKeyword({ commit }, payload) {
    commit('SET_SEARCH_KEYWORD', payload);
  },
};
